import Vue from "vue";
import Router from "vue-router";

import Home from "./views/Home.vue";
import Legislacao from "@/views/Legislacao";
import Ajuda from "@/views/Ajuda";
import Contato from "@/views/Contato";
import Login from "@/views/Login";
import Credenciamento from "@/views/Credenciamento";
import Autenticidade from "@/views/Autenticidade";
import SolicitarSenha from "@/views/SolicitarSenha";
import RecuperarEmail from "@/views/RecuperarEmail";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/legislacao",
      name: "legislacao",
      component: Legislacao
    },
    {
      path: "/ajuda",
      name: "ajuda",
      component: Ajuda
    },
    {
      path: "/contato",
      name: "contato",
      component: Contato
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/credenciamento",
      name: "Credenciamento",
      component: Credenciamento
    },
    {
      path: "/autenticidade",
      name: "Autenticidade",
      component: Autenticidade
    },
    {
      path: "/senha",
      name: "SolicitarSenha",
      component: SolicitarSenha
    },
    {
      path: "/recuperarEmail",
      name: "RecuperarEmail",
      component: RecuperarEmail
    }
  ]
});
